export default __webpack_public_path__ + "static/elevators1-f579d213105f0ab2ae34fa4fa810b496.gif";